import { environment } from '@environments/environment';
import { KeycloakService } from 'keycloak-angular';

export function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        realm: environment.realm,
        url: environment.url,
        clientId: environment.clientId,
      },
      initOptions: {
        checkLoginIframe: false,
      },
      enableBearerInterceptor: true,
      bearerExcludedUrls: ['/assets.*', '.*api/public.*'],
    });
}
